import 'Styles/templates/page.store-details.scss';
import showMoreLess from '../components/show-more-less';
import LazyVideo from '../components/lazy-video';

showMoreLess();
LazyVideo();